import React, { useState, useEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  formateDate,
  getEndOfMonth,
  GetSelectedIDsFromList,
  getStartOfMonth,
} from "../Shared/Utility";
import { useGlobalState } from "../Context/GlobalStateContext";
import MultiSelectionDropdown from "../App/MultiSelectionDropdown";

function FinanceCategories() {
  const globalState = useGlobalState();
  const [showModal, setShowModal] = useState(false);
  const [isAnimation, setIsAnimation] = useState(false);
  const [clearFilters, setClearFilters] = useState(false);
  const [gridData, setGridData] = useState<any>([]);

  const [categoriesList, setCategoriesList] = useState([
    { PID: "Service", Name: "Service (all moving fees)" },
    { PID: "Disposal", Name: "Disposal services (disposal)" },
    { PID: "Additional Liability", Name: "Additional Liability (insurance)" },
    { PID: "Storage", Name: "Storage (storage costs)" },
    { PID: "Materials", Name: "Materials (our boxes, tape etc)" },
    { PID: "Charges", Name: "Charges (parking, PCN, Fine)" },
    { PID: "Boxes", Name: "Boxes (online shop)" },
  ]);

  const [filterObject, setFilterObject] = useState({
    EndDate: getEndOfMonth(),
    StartDate: getStartOfMonth(),
    CategoryID: categoriesList.map((item) => item.PID).join(","),
  });

  const [selectedPIDs, setselectedPIDs] = useState(
    categoriesList.map((item) => item.PID).join(","),
  );

  useEffect(() => {
    ClearFilters(false);
    getFinanceDataByCategory();
  }, [clearFilters]);

  function ClearFilters(clear: boolean) {
    var l_oToday = new Date();

    setFilterObject((prevState: any) => ({
      ...prevState,
      StartDate: new Date(
        l_oToday.getFullYear(),
        l_oToday.getMonth(),
        1,
        10,
        0,
        0,
        0,
      ).toLocaleDateString("en-CA"),
      EndDate: new Date(
        l_oToday.getFullYear(),
        l_oToday.getMonth() + 1,
        0,
        10,
        0,
        0,
        0,
      ).toLocaleDateString("en-CA"),
      JobID: "",
      MNVMoverID: 0,
    }));
    if (clear == true) setClearFilters(!clearFilters);
  }

  function getFinanceDataByCategory() {
    setIsAnimation(true);
    let object = filterObject;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/GetFinanceDataByCategory",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setGridData(l_response);
          console.log(l_response);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function updateSelectedPIDForParent(type: any, value: any, name: any) {
    if (type == 1) {
      filterObject.CategoryID = value;
      setFilterObject((prevState: any) => ({
        ...prevState,
        CategoryID: value,
      }));
    }
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <>
        <div className="flex-d justify-btw flex-gap10">
          <div className="grid-d fr-6 flex-da flex-gap10">
            <div className="field-input input-rel">
              {/* <select
                className="input-field"
                value={filterObject.CategoryID}
                onChange={(e) =>
                  setFilterObject((prevState: any) => ({
                    ...prevState,
                    CategoryID: e.target.value,
                  }))
                }
              >
                <option value="All">All Categories</option>
                <option value="Service">Service (all moving fees)</option>
                <option value="Disposal">Disposal services (disposal)</option>
                <option value="Additional Liability">
                  Additional Liability (insurance)
                </option>
                <option value="Storage">Storage (storage costs)</option>
                <option value="Materials">
                  Materials (our boxes, tape etc)
                </option>
                <option value="Charges">Charges (parking, PCN, Fine)</option>
                <option value="Boxes">Boxes (online shop)</option>
              </select> */}
              <MultiSelectionDropdown
                listData={categoriesList}
                selectAllName={"All Categories"}
                selectFewName={"Categories"}
                updateSelectedPIDForParent={updateSelectedPIDForParent}
                type={1}
                selectedPID={selectedPIDs}
              ></MultiSelectionDropdown>
            </div>
            <div className="field-input date-field">
              <input
                type="date"
                title="Service Start Date"
                value={filterObject.StartDate}
                onChange={(e) =>
                  setFilterObject((prevState: any) => ({
                    ...prevState,
                    StartDate: e.target.value,
                  }))
                }
                className="input-field "
              />
            </div>
            <div className="field-input date-field">
              <input
                type="date"
                title="Service End Date"
                value={filterObject.EndDate}
                onChange={(e) =>
                  setFilterObject((prevState: any) => ({
                    ...prevState,
                    EndDate: e.target.value,
                  }))
                }
                className="input-field w-100 "
              />
            </div>

            <div className="flex-daj btn-start flex-gap10">
              <a
                onClick={() => ClearFilters(true)}
                className="btn-primary flex-daj"
              >
                Clear Filters
              </a>
              <a
                onClick={() => getFinanceDataByCategory()}
                className="btn-primary flex-daj"
              >
                Filter
              </a>
            </div>
          </div>

          <div className="flex-d btn-start flex-gap10">
            <a
              className="btn-primary flex-daj btn-grid"
              title="Export"
              onClick={() =>
                DownloadClientsDataInExcel(
                  "tblmarketingscore",
                  "Finance Categories",
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>
        </div>
        <div className="grid-d fr-1111 flex-gap10 mt-20">
          {gridData[0] &&
            gridData[0].map((Item: any, index: any) => (
              <React.Fragment key={index}>
                <div
                  className="data-boxes pointer"
                  onClick={(e) => {
                    filterObject.CategoryID = Item.LineItemCategory;
                    setFilterObject((prevState: any) => ({
                      ...prevState,
                      CategoryID: Item.LineItemCategory,
                    }));

                    getFinanceDataByCategory();
                  }}
                >
                  <span className="data-txt">{Item.LineItemCategory}</span>
                  <span>
                    £
                    {Item.TotalAmount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
              </React.Fragment>
            ))}
        </div>
        <div className="flow-auto mt-10">
          <table className="reuse-table" id="tblmarketingscore">
            <thead>
              <tr>
                <th>Category</th>
                {<th>Job ID</th>}
                <th>Dated</th>
                <th>Title</th>
                <th>Net Amount</th>
                <th>VAT</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody>
              {gridData[1] &&
                gridData[1].map((Item: any, index: any) => (
                  <React.Fragment key={index}>
                    <tr key={index}>
                      <td>{Item.LineItemCategory}</td>
                      <td>
                        {" "}
                        <a
                          href={
                            Item?.MNVJobID
                              ? `/quote_detail/${Item.MNVJobID}`
                              : "#"
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {Item.JobID}
                        </a>
                      </td>
                      <td>{formateDate(Item.CreationTimestamp)}</td>
                      <td>{Item.TextToDisplay}</td>
                      <td className="text-right">
                        £
                        {Number(Item.Amount).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="text-right">
                        £
                        {Number(Item.VAT).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="text-right">
                        £
                        {Number(Item.AmountWithVAT).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
            </tbody>
          </table>
        </div>
      </>
    </div>
  );
}

export default FinanceCategories;
